import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useGetSelectedListStore } from '#stores/getSelectedList';
import useWishlists from './useWishlists';
import { getUserGuid } from '#utils/UserDetails';
import { storeTemporaryGuestListGuid } from '#utils/temporaryGuestListStorage';
import { headers } from 'config';

export default function useWishlistDetails() {
  const route = useRoute();
  const router = useRouter();
  const selectedListStore = useGetSelectedListStore();
  const { defaultWishlistGuid, userFirstName } = useWishlists();

  const wishlistGuidFromQuery = computed(() => route.query.listGuid);
  const wishlistGuid = computed(() => wishlistGuidFromQuery.value || defaultWishlistGuid.value);
  const wishlistDetailsResponse = computed(() => selectedListStore.selectedListOfUser);
  const isWishlistLoading = computed(() => selectedListStore.selectedListLoadingState);
  const currentWishlist = computed(() => wishlistDetailsResponse.value?.list?.[0]);
  const currentWishlistItems = computed(() => currentWishlist.value?.items);
  const wishlistName = computed(() => currentWishlist.value?.name || (userFirstName.value && `${userFirstName.value}’s List`) || 'Guest List');
  const isDefaultWishlist = computed(() => currentWishlist.value?.defaultList);
  const numberOfWishlistItems = computed(() => currentWishlistItems.value?.length || 0);
  const wishlistUserDetails = computed(() => wishlistDetailsResponse.value?.user);
  const isWishlistOwner = computed(() => wishlistUserDetails.value?.guid === getUserGuid());
  const isSharedList = computed(() => !!(wishlistUserDetails.value?.guid && wishlistUserDetails.value?.guid !== getUserGuid()));
  const wishlistOnSaleNotify = computed(() => currentWishlist.value?.onSaleNotify);
  const wishlistSearchable = computed(() => currentWishlist.value?.searchable);
  const isGuestUserList = computed(() => wishlistDetailsResponse.value?.user?.guestUser);

  const loadWishlistDetails = async () => {
    if (wishlistGuid.value) {
      if (!wishlistGuidFromQuery.value) {
        router.replace({ query: { ...route.query, listGuid: wishlistGuid.value } });
      }
      await selectedListStore.getSpecificList({
        listGuid: wishlistGuid.value,
        headers,
      });

      if (isGuestUserList.value && wishlistGuid.value) {
        storeTemporaryGuestListGuid(wishlistGuid.value);
      }
    }
  };

  return {
    loadWishlistDetails,
    currentWishlist,
    numberOfWishlistItems,
    isWishlistLoading,
    wishlistGuid,
    wishlistGuidFromQuery,
    isDefaultWishlist,
    wishlistName,
    currentWishlistItems,
    wishlistUserDetails,
    isWishlistOwner,
    isSharedList,
    wishlistOnSaleNotify,
    wishlistSearchable,
    isGuestUserList,
  };
}
